import { TenantAppShell } from '@/app/tenant-app-shell';
import { tryRefreshToken } from '@features/login';

import './app.css';

import { router } from './app.router';

function App() {
	return (
		<TenantAppShell
			router={router}
			refresh={{ tryRefreshToken, intervalMs: 30 * 1000 }}
		/>
	);
}

export default App;
